import store from './store'
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n'
import { persistStore } from 'redux-persist'
import translations from 'translations'

export default () => {
  return new Promise(resolve => {
    syncTranslationWithStore(store);
    store.dispatch(loadTranslations(translations));
    store.dispatch(setLocale('en'));
    let persistor = persistStore(store);
    resolve({ persistor, store });
  });
}
